export default {
    meta: {
        title: '拓店宝-拓店任务指派'
    }
};
